import React, {useState} from "react";
import DefaultAuth from "../../../components/auth/Default";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Text,
} from "@chakra-ui/react";

function SignIn() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [succes, setSucces] = useState("");
  const [email, setEmail] = useState("");
  const textColor = "navy.700";
  const textColorSecondary = "gray.400";
  const brandStars = "brand.500";
  const cardColor = 'gray.50';
  
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const requestBody = {
      email: email,
    };
    
    setLoading(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      };
      
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}auth/reset/`,
        requestOptions
      );
      
      if (response.ok) {
        setSucces(true)
      } else {
        setError("Girdiğiniz E-posta adresine kayıtlı bir hesap yok");
      }
    } catch (error) {
      setError("Bir hata oluştu, lütfen tekrar deneyin");
    } finally {
      setLoading(false);
    }
  };

  const boxStyle = {
    boxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)',
    WebkitBoxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)',
    MozBoxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)'
  };
  
  return (
    <form onSubmit={handleFormSubmit}>
    <DefaultAuth
      illustrationBackground={"https://inohom.b-cdn.net/newImages/inohomtrlogo.png"}
    >
      <Flex
        style={boxStyle}
        bg={cardColor}
        maxW={{base: "max-content", md: "max-content"}}
        boxShadow='xl' p='6' rounded='md'
        borderRadius="10px"
        alignItems="start"
        justifyContent="center"
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Şifre yenileme
          </Heading>
          <Text
            maxW={"420px"}
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Hesabınıza Ait E-Posta adresini girerek şifre yenileme bağlantısı alabilirsiniz
          </Text>
        </Box>
        <Flex
          direction="column"
          w={{base: "100%", md: "420px"}}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{base: "auto", lg: "unset"}}
          me="auto"
          mb={{base: "10px", md: "auto"}}
        >
          <FormControl isInvalid={error !== ""}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              E-posta adresiniz:<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="email"
              placeholder=""
              fontWeight="500"
              size="lg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>
            <Button
              mt="24px"
              backgroundColor={"#660000"}
              color={"#fff"}
              fontSize="sm"
              variant="brand"
              borderRadius={9}
              onClick={handleFormSubmit}
              fontWeight="500"
              w="100%"
              h="50"
              isLoading={loading}
              mb="24px"
              type="submit"
              isDisabled={succes}
            >
              Şifre yenileme bağlantısı gönder
            </Button>
          {succes && (
            <Alert status='success' variant='left-accent'>
              <AlertIcon />
              Şifre yenileme bağlantısı e-posta adresinize gönderildi
            </Alert>
          )}
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px">
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
    </form>
  );
}

export default SignIn;
